import styled from 'styled-components';

/**
 * WebGL-free fallback for the Ribbon Symphony scene. Renders a calm white field
 * with a few soft, static ribbon arcs in the orchestra-section colours, so the
 * concept survives on reduced-motion, weak devices, or while the 3D layer loads.
 */

const Field = styled.div`
  position: absolute;
  inset: 0;
  background: var(--kph-welcome-bg, #ffffff);
  overflow: hidden;
`;

const Arc = styled.span`
  position: absolute;
  left: 50%;
  top: 50%;
  width: 78vmin;
  height: 78vmin;
  border-radius: 50%;
  transform-origin: center;
  filter: blur(2px);
  opacity: 0.55;
`;

export const StaticBackdrop = () => (
  <Field aria-hidden="true">
    <Arc
      style={{
        transform: 'translate(-50%, -50%) rotate(-18deg) scale(1)',
        border: '6px solid transparent',
        borderTopColor: 'var(--kph-gold, #d4af37)',
        borderRightColor: 'rgba(212, 175, 55, 0.25)',
      }}
    />
    <Arc
      style={{
        transform: 'translate(-50%, -50%) rotate(54deg) scale(0.82)',
        border: '5px solid transparent',
        borderTopColor: 'var(--kph-copper, #b87333)',
        borderLeftColor: 'rgba(184, 115, 51, 0.22)',
      }}
    />
    <Arc
      style={{
        transform: 'translate(-50%, -50%) rotate(128deg) scale(1.16)',
        border: '4px solid transparent',
        borderTopColor: 'var(--kph-silver, #c0c0c0)',
        borderBottomColor: 'rgba(192, 192, 192, 0.2)',
      }}
    />
    <Arc
      style={{
        transform: 'translate(-50%, -50%) rotate(201deg) scale(0.94)',
        border: '4px solid transparent',
        borderTopColor: 'var(--kph-percussion, #bfc0cd)',
        borderRightColor: 'rgba(191, 192, 205, 0.25)',
      }}
    />
  </Field>
);
